//i know i know i could have turned it into an array and mapped it over but this was just easy and i was getting lazy and also dropped few options again the approach is same as in the left side handler again getting a bit lazy
export const irctcTrains =
    <>
        <span>
            Salient Features
        </span>
        <span>
            Ticket Cancellation Rules
        </span>
        <span>
            Foreign Tourist T&C
        </span>
        <span>
            Group Booking T&C
        </span>
        <span>
            Travel Insurance Claim Process
        </span>
    </>

export const generalInfo =
    <>
        <span>
            More info

        </span>
        <span>
            FAQs

        </span>
        <span>
            Terms & Conditions

        </span>
        <span>
            Travel Insurance T&C

        </span>
        <span>
            FTR T&C

        </span>
        <span>
            Scheme for issue of waitlisted E-tickets

        </span>
        <span>
            Protect against fraudulent emails

        </span>
        <span>
            General Guideline for SUVIDHA trains

        </span>
        <span>
            Current booking Guidelines

        </span>
        <span>
            Forgo Senior Citizen Concession-FAQ

        </span>
        <span>
            Trains at a Glance

        </span>
        <span>Guidelines for Boarding Station change</span>
        <span>
            Guideline for PASS Booking

        </span>
    </>

export const impinfo =
    <>
        <span>
            Bank Transaction Charges
        </span>
        <span>
            Women Sr. Citizen Concession
        </span>
        <span>
            VIKALP Scheme
        </span>
        <span>
            Travel Insurance (Incl. of GST)
        </span>
        <span>
            Browser Settings
        </span>
    </>

export const agents =

    <>
        <span>
            IRCTC Authorized Service Providers
        </span>
        <span>
            Digital Certificate Generation Process
        </span>
        <span>
            Blacklist Agent
        </span>
        <span>
            Find NgeT Agents
        </span>
        <span>
            Rules and Regulations for the Agents
        </span>
        <span>
            Norms for RTSA
        </span>
        <span>
            Norms for IATA
        </span>
        <span>
            Norms for GSA
        </span>
        <span>
            Norms for Internet Cafe Scheme
        </span>
        <span>
            Norms for B2B Scheme
        </span>
        <span>
            Norms for B2C & Mobile Scheme
        </span>
        <span>
            Registration Form
        </span>
        <span>
            Requisition Slip
        </span>
    </>

export const enquries =
    <>
        <span>
            Reservation Enquiries
        </span>
        <span>
            PNR Enquiry
        </span>
        <span>
            Train Enquiry
        </span>
        <span>
            Train/Fare Accommodation
        </span>
        <span>
            Train Between Important Stations
        </span>
        <span>
            Railway Enquiry-139
        </span>
    </>

export const howto =
    <>
        <span>
            Register
        </span>
        <span>
            Book E-ticket (PDF) (VIDEO)
        </span>
        <span>
            Book tatkal ticket
        </span>
        <span>
            Book Concession Tickets for Person With Disability
        </span>
        <span>
            Cancel E-ticket
        </span>
        <span>
            International/NRI User Registration Guide
        </span>
        <span>
            Change Boarding Point
        </span>
        <span>
            Link Your Aadhaar
        </span>
        <span>
            File TDR
        </span>
    </>

export const irctcofficalapp =
    <>
        <span>
            RCTC Rail Connect (Android)
        </span>
        <span>
            IRCTC Rail Connect (iOS)
        </span>
        <span>
            IRCTC Order Food (Android)
        </span>
        <span>
            IRCTC Order Food (IOS)
        </span>
        <span>
            IRCTC Tourism App
        </span>
        <span>
            IRCTC Air App (Android)
        </span>
        <span>
            IRCTC Air App (IOS)
        </span>
        <span>
            IRCTC iMudra (Android)
        </span>
    </>


export const advertisewithus =
    <>
        <span>
            IRCTC Marketing Statistics
        </span>
        <span>
            Banner-Advertisement
        </span>
        <span>
            Banner Locations on IRCTC
        </span>
        <span>
            Push Notification
        </span>
        <span>
            Chat Bot Advertisement
        </span>
        <span>
            Chat Bot : As a IRCTC Service
        </span>
        <span>
            Cuboid Advertisement
        </span>
        <span>
            e-Ticket(ERS) Advertisement
        </span>
        <span>
            Logout Advertisement
        </span>
        <span>
            139-Jingles
        </span>
        <span>
            SMS(Promotional)
        </span>
        <span>
            Booking Mail Advertisement
        </span>
        <span>
            Cancellation Mail Advertisement
        </span>
        <span>
            Mailer(Promotional)
        </span>
        <span>
            Captcha Advertisement
        </span>
        <span>
            Advertisement Disclaimer
        </span>
    </>

export const refundrules =
    <>
        <span>
            Ticket Cancellation & Refund Rules
        </span>
        <span>
            Gazette: Cancellation of Ticket and Refund Rules 2015
        </span>
        <span>
            Refund Rule of Suvidha Train
        </span>
        <span>
            Refund Rule COVID19 - RB 13.05.2020
        </span>
    </>

export const persondis =
    <>
        <span>
            Facilities for Person With Disability Users
        </span>
        <span>
            Facilities for Visually Impaired Users
        </span>
        <span>
            User Guide: Person With Disability Booking
        </span>
    </>

export const irctcewallet =
    <>
        <span>About</span>
    </>

export const irctcpaymentgate =
    <>
        <span>
            IRCTC-iPAY (PDF) (VIDEO)
        </span>

        <span>AutoPay</span>

    </>

export const irctczones =
    <>
        <span>
            Jago yatri jago
        </span>
        <span>
            Jansankhya Sthirata Kosh
        </span>
        <span>
            Maharaja"s Express
        </span>
    </>


export const fornewlymigclients =
    <>
        <span>
            Login Manual - from old site to new site
        </span>
        <span>
            Operating Manual for new e-ticketing website
        </span>
        <span>
            Operating Manual for Agent Interface Application
        </span>
    </>


export const mobilezones =
    <>
        <span>
            IRCTC Android App - IRCTC Rail Connect
        </span>
        <span>
            ClearTrip
        </span>
        <span>
            Airtel
        </span>
        <span>
            Amazon India - Shop & Pay
        </span>
        <span>
            Confirmtkt
        </span>
        <span>
            EaseMyTrip Flight, Hotel, Train
        </span>
        <span>
            Google Pay
        </span>
        <span>
            Goibibo
        </span>
        <span>
            MakeMyTrip
        </span>
        <span>
            Ixigo Trains
        </span>
        <span>
            Ixigo Flights
        </span>
        <span>
            PayTM
        </span>
        <span>
            JustDial
        </span>
        <span>
            redRail
        </span>
        <span>
            redBus
        </span>
        <span>
            Railofy
        </span>
        <span>
            Railyatri
        </span>
        <span>
            Trainman
        </span>
        <span>
            SBI YONO
        </span>
        <span>
            Yatra
        </span>
        <span>
            udChalo
        </span>
        <span>
            Kotak
        </span>
        <span>
            ICICI
        </span>
        <span>
            HDFC PayZapp
        </span>
        <span>
            Tripozo
        </span>
    </>

export const askDisha =
    <>
        <span>
            Services of Ask Disha ChatBot
        </span>
        <span>
            Features of Ask Disha ChatBot
        </span>

    </>

export const aboutus =

    <>
        <span>Awards & Achievements</span>
    </>

export const ReservationCategory = [
    { value: 'GENERAL', label: 'GENERAL' },
    { value: 'LOWER BERTH/SR.CITIZEN', label: 'LOWER BERTH/SR.CITIZEN' },
    { value: 'PERSON WITH DISABILITY', label: 'PERSON WITH DISABILITY' },
    { value: 'DUTY PASS', label: 'DUTY PASS' },
    { value: 'TATKAL', label: 'TATKAL' },
    { value: 'PREMIUM TATKAL', label: 'PREMIUM TATKAL' },

];

export  const ReservationClass = [
    { value: 'ALL CLASSES', label: 'ALL CLASSES' },
    { value: 'Anubhuti Class (EA)', label: 'Anubhuti Class (EA)' },
    { value: 'AC First Class (1A)', label: 'AC First Class (1A)' },
    { value: 'Vistadome AC (EV)', label: 'Vistadome AC (EV)' },
    { value: 'Exec. Chair Car (EC)', label: 'Exec. Chair Car (EC)' },
    { value: 'AC 2 Tier (2A)', label: 'AC 2 Tier (2A)' },
    { value: 'First Class (FC)', label: 'First Class (FC)' },
    { value: 'AC 3 Economy (3E)', label: 'AC 3 Economy (3E)' },
    { value: 'Vistadome Chair Car (VC)', label: 'Vistadome Chair Car (VC)' },
    { value: 'AC Chair car (CC)', label: 'AC Chair car (CC)' },
    { value: 'Sleeper (SL)', label: 'Sleeper (SL)' },
    { value: 'Vistadome Non AC (VS)', label: 'Vistadome Non AC (VS)' },
    { value: 'Secound Sitting (2S)', label: 'Secound Sitting (2S)' },
];

export const GenderOptions = [
    { value: 'Gender', label: 'Gender' },
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' },
    { value: 'Transgender', label: 'Transgender' },
];

export const NationalityOptions = [
    { value: 'Bharat', label: 'Bharat' },
];

export const BerthPrefrencerOptions = [
    { value: 'No Prefrence', label: 'No Prefrence' },
    { value: 'Lower', label: 'Lower' },
    { value: 'Middle', label: 'Middle' },
    { value: 'Upper', label: 'Upper' },
    { value: 'Side Lower', label: 'Side Lower' },
    { value: 'Side Upper', label: 'Side Upper' },
];
